import colors from '@constants/colors';
import styled from '@emotion/styled';
import ControlIcon from '@icons/Control';
import { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

import FilterContext, { FilterContextProps } from './context/FilterContext';
import FilterExpand from './FilterExpand';

type Props<S, F> = Omit<FilterContextProps<S, F>, 'isOpen' | 'setIsOpen'>;

function Filter<S, F>(props:Props<S, F>) {
    const {
        title, sort, setSort, sortItems, filters, setFilters, filterItems, ...rest
    } = props;
    const filterLabel = useMemo(() => {
        if (!filterItems || !filters) return '';
        return filterItems?.filter((item) => filters.includes(item.value))?.[0]?.label;
    }, [filters, filterItems, sort]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    return (
        <FilterContext value={{ ...props, isOpen, setIsOpen }}>
            <Container>
                <Button {...rest} onClick={() => setIsOpen(true)}>
                    <ControlIcon color={colors.gray7} size={24}/>
                </Button>
                {filterLabel && (<Dot/>)}
                {createPortal(<FilterExpand/>, document.body)}
            </Container>
        </FilterContext>
    );
}

const Container = styled.div`
    position: relative;    
`;

const Button = styled.div`
    background-color: var(--color-gray1);
    padding: 8px 16px;
    border-radius: 12px;
`;

const Dot = styled.div`
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: var(--color-red);
    position: absolute;
    right: 0;
    top: 0;
`;

export default Filter;
